import PortfolioCreativeFullContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioCreativeFull";

const PortfolioCreativeFull = () => {
  return <PortfolioCreativeFullContainer />;
};

export default PortfolioCreativeFull;
